import React from 'react';
import { FullPageLoader } from 'prosci-ui';

const LoadingBar = () => <FullPageLoader message="" />;

export default LoadingBar;